import * as qs from "qs";

interface Config extends RequestInit {
  data?: object;
  url?: string;
}
export const http = async (
  endpoint: string,
  { data, headers, url, ...customConfig }: Config = {},
) => {
  const backendUrl = url;

  const config = {
    method: "GET",
    ...customConfig,
  };
  if (config.method.toUpperCase() === "GET") {
    if (config.method.toUpperCase() === "GET") {
      endpoint += `?${qs.stringify(data)}`;
    }
  } else {
    config.body = JSON.stringify(data || {});
  }

  return window
    .fetch(`${backendUrl}/${endpoint}`, config)
    .then(async (response) => {
      const data = await response.json();
      if (response.ok) {
        return data;
      } else {
        return Promise.reject(data);
      }
    });
};
